export const DefectStatus = {
  open: { value: 'open', name: 'otwarte' },
  resolved: { value: 'resolved', name: 'zamknięte - regulacja' },
  rejected: { value: 'rejected', name: 'odrzucone' },
  resolvedWithParts: { value: 'resolvedWithParts', name: 'zamknięte - wymiana części' },
};
